import { fetcher } from '@commenda/utils';

// Forks a new DRAFT revision from a live (PUBLISHED/SENT) quote. The response body is the
// new revision — consumers read it to route into its editor.
export const reviseBillingQuote = async (
  quoteId: string,
  revisionNote?: string
) => {
  const response = await fetcher(`commenda-billing/quotes/${quoteId}/revise`, {
    method: 'POST',
    body: revisionNote ? { revisionNote } : {},
  });

  return response;
};
